import classes from "../ServicesTable.module.scss"
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Container, Row , Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useForm, Controller  } from "react-hook-form";
import { TextField } from "../../integrationWizard/form/TextField";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { servicesEditFields as servicesEditFieldsDefault, fieldsLayout as fieldLayoutDefault } from "./servicesColumns";
import Button from "../../UI/Button";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OutboxIcon from '@mui/icons-material/Outbox';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import LoginIcon from '@mui/icons-material/Login';
import StartIcon from '@mui/icons-material/Start';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ReactHookFormSelect from "./ReactHookFormSelect";
import CertificateField from "../CertificateField";
import CertificateInput from "./CertificateInput";
import { OrgIdContext } from "../../../store/orgId_context";
import { DDD, E2Data } from "../../../lib/ddd/ddd";
import { GenericTooltip } from "../../integrationWizard/form/GenericTooltip";
import {stringExpressionReplacement} from "../../../lib/ddd/helpers"
import { NotificationManager} from 'react-notifications';
import { Button as MButton, Dialog, DialogActions, DialogContent, DialogTitle,FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import FiscalizationForm from "../devices/FiscalizationForm";
import { useQuery } from "@tanstack/react-query";
import ServicesFormWorkflows from "../devices/ServicesFormWorkflows";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";
import PrintIcon from "@mui/icons-material/Print"; 
import HelpIcon from '@mui/icons-material/Help';
import { Collapse } from "@mui/material";
import axios from "axios";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const apiSource = process.env.REACT_APP_ORIGIN || window.location.origin;
const ddd = new E2Data("EU_AOrg_ServicesEndpoints");
const _ddd = new DDD(apiRequestAddress);

const ServiceForm = ({data:importedData, orgData, info, onSubmit:submitCallback, editable=true, refetch}) => {
    const [data, setData] = useState([]);
    const [fields, setFields] = useState({});
    const [defaults, setDefaults] = useState({});
    const [showPasswords, setShowPasswords] = useState(false);
    const [activateError, setActivateError] = useState();
    const [testOk, setTestOk] = useState();
    const [confirmDialog,setConfirmDialog] = useState(false);
    const [confirmAnafDialog,setConfirmAnafDialog] = useState(false);
    const [instructionsDialog,setInstructionsDialog] = useState(false);
    const [deactivateBtn, setDeactivateBtn] = useState(false);
    const [unlistedFields, setUnlistedFields] = useState([]);
    const [connectedFields, setConnectedFields] = useState([]);
    const [instructions, setInstructions] = useState();
    const [servicesEditFields, setServicesEditFields] = useState(servicesEditFieldsDefault);
    const [fieldsLayout, setFieldsLayout] = useState(fieldLayoutDefault?.groups || []);
    const [error, setError] = useState();
    const [tokenLoading, setTokenLoading] = useState(false);
    const [openLongTooltips, setOpenLongTooltips] = useState({});
    const { isMaintainer, sessionInfo, connectionKey } = useContext(OrgIdContext);
    const fiscForm = useRef(null);
    const workflowsForm = useRef(null);
    const navigate = useNavigate();
    const {t} = useTranslation();
    //const [anafToken, setAnafToken] = useState();
    
    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
    } = useForm();
//#region field helpers
    const getHardcodedFieldInfo = (fieldName) =>{
        return servicesEditFields.filter(obj => obj.name === fieldName)[0];
    }
    const getFieldValue = (fieldName) => {
        if(data.hasOwnProperty(fieldName))
            return data[fieldName];
        return null;
    }
    const getFieldInfo = (fieldName, skip) => {
        if(!fields)
            return {};
        
        if(fields.hasOwnProperty(fieldName) && !skip)
            return fields[fieldName];
        const hinfo = getHardcodedFieldInfo(fieldName);
        if(hinfo?.groupFields && hinfo?.groupFields.length > 0){
            let tmp = fields;
            hinfo.groupFields.forEach((master) => {
                if(tmp.hasOwnProperty(master)){
                    tmp = tmp[master];
                }else if(tmp._groupFields && tmp._groupFields.hasOwnProperty(master)){
                    tmp = tmp._groupFields[master];
                }
            })

            if(tmp._groupFields && tmp._groupFields.hasOwnProperty(fieldName))
                return tmp._groupFields[fieldName];
        }
        
        return {};
    }
    const getValidValues = (fieldName) => {
        let ret = [];
        const _info = getFieldInfo(fieldName);
        if(!_info || !_info._validValues)
            return ret;
        _info._validValues.forEach(el => ret.push(el.Title))
        return ret;
    }
    const getValidValuesMerged = (fieldName) => {
        let ret = [];
        const _info1 = getFieldInfo(fieldName);
        const _info2 = getFieldInfo(fieldName, true);
        if(_info1 && _info1._validValues){
            _info1._validValues.forEach(el => ret.push(el.Title))
        }
        if(_info2 && _info2._validValues){
            _info2._validValues.forEach(el => {
                if(ret.indexOf(el.Title) < 0)
                    ret.push(el.Title);
            })
        }
        return ret;
    }
    const getDefaultValues = () =>{
        let defaults = {}
        servicesEditFields.forEach(field => {
            if(!getRulesFields().includes(field.name)) return;
            defaults[field.name] = getFieldValue(field.name);
        })
        unlistedFields.forEach(field => {
            if(!field || field.indexOf("__")>-1) return;
            defaults[field] = getFieldValue(field);
        })
        return defaults;
    }

    const getIconForDirection = (direction) =>{
        switch(direction){
            case "Recieve":
                return <MoveToInboxIcon/>
            case "Send":
                return <OutboxIcon/>
            case "Both":
                return <ImportExportIcon/>
            case "PushREI":
                return <LoginIcon style={{transform:"rotate(-90deg)"}}/>
            case "PushIEI":
                return <StartIcon style={{transform:"rotate(-90deg)"}}/>
            case "Push":
                return <CloudUploadIcon/>
            default:
                return <OutboxIcon/>
        }
    }
    const getIconForType = (type) =>{
        switch(type){
            case "PublicSector":
                return <PublicIcon/>
            case "PrivateSector":
                return <PublicOffIcon/>
            case "All":
                return <AllInclusiveIcon/>
            default:
                return <AllInclusiveIcon/>
        }
    }
    const getIconForAll = (val) =>{
        if(["PublicSector", "PrivateSector", "All"].indexOf(val) >= 0)
            return getIconForType(val);
        return getIconForDirection(val);
    }
    const isFieldEditable = (fieldName) => {
        return getRulesFields().includes(fieldName);
    }
    const getRules = () => {
        if(isMaintainer && importedData.ServiceEndPointCode__MaintainerUIRules)
            return importedData.ServiceEndPointCode__MaintainerUIRules;
        if(importedData.ServiceEndPointCode__UserUIRules)
            return importedData.ServiceEndPointCode__UserUIRules;
        return "";
    }
    const getRulesFields = () =>{
        let fields = [];
        const uirules = importedData.ServiceEndPointCode__UserUIRules || importedData.UserUIRules || false;
        const mrules = importedData.ServiceEndPointCode__MaintainerUIRules || importedData.MaintainerUIRules || false;

        if(uirules) fields = getRulesAsArray(uirules);
        if(isMaintainer && mrules){
             let mfields = getRulesAsArray(mrules);
             mfields.forEach(item => fields.includes(item) ? null : fields.push(item));
        }
        return fields;
    }
    const getUnlistedFields = () =>{
        const allFields = getRulesFields();
        const ret = [];
        for(let i=0;i<allFields.length;i++){
            if(allFields[i].indexOf("__")>-1)continue;
            let found = false;
            for(let y=0;y<servicesEditFields.length;y++){
                if(servicesEditFields[y].name === allFields[i]) found=true;
            }
            if(!found) ret.push(allFields[i]);
        }
        return ret;
    }
    const getConnectedFields = () =>{
        const allFields = getRulesFields();
        const ret = [];
        for(let i=0;i<allFields.length;i++){
            if(allFields[i].indexOf("__")>-1)
                ret.push(allFields[i]);
        }
        return ret;
    }
    const getRulesAsArray = (str) => {
        const ret = [];
        if(!str) return ret;
        str = str.replace(/[\[\] *]/g, "");
        if(!str || str.length === 0) return ret;
        return str.split(",");
    }
    const isGroupEditable = (group) =>{
        for(let i =0;i<servicesEditFields.length;i++){
            if(servicesEditFields[i].group ===  group && isFieldEditable(servicesEditFields[i].name))
                return true;
        }
        return false;
    }
    const getEditableData = (newData) => {
        let ret ={};
        for(const [key, val] of Object.entries(newData)){
            if(getRulesFields().includes(key))
                ret[key] = val;
        }
        return ret;
    }
    //#endregion field helpers

    const getFieldElement = (fieldName, props) => {
        const _info = getFieldInfo(fieldName);
        const hFieldInfo = getHardcodedFieldInfo(fieldName);
        let type = hFieldInfo?.type;
        if(!type) type = _info?.FieldType;

        const val = getFieldValue(fieldName);
        
        switch(type){
            case "textarea":
            case "TextArea":
                return(
                    <textarea
                    key={fieldName+"field"}
                    placeholder={hFieldInfo?.placeholder || "Enter email"}
                    rows="3"
                    disabled={!editable || hFieldInfo?.editable === false}
                    {...props}
                    {...register(fieldName)}
                />
                )
            case "mail":
                return(
                    <input
                    key={fieldName+"field"}
                    placeholder={hFieldInfo?.placeholder || "Enter email"}
                    type="email"
                    disabled={!editable || hFieldInfo?.editable === false}
                    {...register(fieldName)}
                />
                )
            case "datetime":
            case "DateTime":
                return(
                    <input
                    key={fieldName+"field"}
                    type="datetime-local"
                    disabled={!editable || hFieldInfo?.editable === false}
                    step="1"
                    {...register(fieldName)}
                />
                )
            case "file":
                return (
                    <>
                    <CertificateInput
                    name={fieldName}
                    register={register}
                    setValue={setValue}
                    disabled={!editable || hFieldInfo?.editable === false}
                    control={control}
                    />
                </>)
            case "date":
                return (<input
                    key={fieldName+"field"}
                    type="date"
                    disabled={!editable || hFieldInfo?.editable === false}
                    {...register(fieldName)}
                />)
            case "password":
                return (
                <>
                <div className="input-group" style={{flexWrap:"nowrap"}}>    
                <input
                    key={fieldName+"field"}
                    placeholder={hFieldInfo.placeholder || "Enter password"}
                    autocomplete="new-password"
                    disabled={!editable || hFieldInfo?.editable === false}
                    type={showPasswords ? "text" : "password"}
                    {...register(fieldName)}
                />
                    <span onClick={() => setShowPasswords(val => !val)} className="input-group-text" style={{border:"none", outline:"1.5px solid #005683", backgroundColor:"white", cursor:"pointer"}}>
                        <VisibilityIcon style={{fontSize:"1rem"}}/>
                    </span>
                </div>
                </>)
            case "bool":
                let menuItems = [{value : true, title : "True", icon:(<CheckCircleIcon/>)}, {value:false, title:"False", icon:(<UnpublishedIcon/>)}];
                return (
                    <Controller
                     control={control}
                     name={fieldName}
                     disabled={!editable || hFieldInfo?.editable === false}
                     key={fieldName+"field"}
                     defaultValue={val}
                     render= {(({field})=>{
                    return(<Select
                        className={classes["inputselect"]}
                        style={{borderRadius:"10px"}}
                        disabled={!editable || hFieldInfo?.editable === false}
                        key={fieldName+"field"}
                        {...field}
                        >
                            {menuItems.map((value, index) => (
                                <MenuItem value={value.value} key={index}>
                                    {value.icon} {value.title}
                                </MenuItem>
                            ))}
                            
                    </Select>)
                    })}/>)
            case "select":
                let validValues = getValidValuesMerged(fieldName);
                return (
                    <Controller
                     control={control}
                     name={fieldName}
                     disabled={!editable || hFieldInfo?.editable === false}
                     defaultValue={val}
                     key={fieldName+"field"}
                     render= {(({field})=>{
                    return(<Select
                        className={classes["inputselect"]}
                        style={{borderRadius:"10px"}}
                        key={fieldName+"field"}
                        disabled={!editable || hFieldInfo?.editable === false}
                        {...field}
                        >
                            {validValues.map((value, index) => (
                                <MenuItem value={value} key={fieldName+"field"+index}>
                                    {getIconForAll(value)} {value}
                                </MenuItem>
                            ))}
                            
                    </Select>)
                    })}/>)
            default:
                return (<input
                            key={fieldName+"field"}
                            disabled={!editable || hFieldInfo?.editable === false}
                            placeholder={hFieldInfo?.placeholder || ""}
                            {...register(fieldName)}
                        />)
        }
    }
    

    useEffect(() => {
        if(importedData){
            setData(importedData);
        }
        if(info && info._fields)
            setFields(info._fields);
        
        setUnlistedFields(getUnlistedFields());
        setConnectedFields(getConnectedFields());
    }, [importedData, info])

    useEffect(() => {
        setDefaults(getDefaultValues());
        reset(getDefaultValues())
    }, [fields, data]);

    useEffect(() => {
        if(data?.ServiceEndPointCode__AdditionalUIRules){
            try{
                const instructions = JSON.parse(data?.ServiceEndPointCode__AdditionalUIRules);
                delete instructions?.FiscDeviceRegCode;
                delete instructions?.FiscOperatorRegCodeDef;
                delete instructions?.FiscUnitRegCodeDef;
                if(Object.keys(instructions).length > 0)
                    setInstructions(instructions);
            }catch(e){
                console.error(e);
            }
        }
        if(data?.ServiceEndPointCode__UILayout){
            try{
                const layout = JSON.parse(data?.ServiceEndPointCode__UILayout);
                if(layout?.groups?.length > 0){
                    let newFields = [...fieldLayoutDefault.groups];
                    let imported = layout.groups;
                    const map = {};
                    newFields.forEach(field => {
                        map[field.name] = { ...field };
                    });
                    imported.forEach(item => {
                        if (map[item.name]) {
                            map[item.name] = { ...map[item.name], ...item };
                        } else {
                            map[item.name] = { ...item };
                        }
                    });
                    const merged = Object.values(map).sort((a, b) => (a.order || 0) - (b.order || 0));
                    setFieldsLayout(merged);
                }
                if(layout?.fields?.length > 0){
                    let newFields = [...servicesEditFieldsDefault];
                    let imported = layout.fields;
                    const map = {};
                    newFields.forEach(field => {
                        map[field.name] = { ...field };
                    });
                    imported.forEach(item => {
                        if (map[item.name]) {
                            map[item.name] = { ...map[item.name], ...item };
                        } else {
                            map[item.name] = { ...item };
                        }
                    });
                    const merged = Object.values(map).sort((a, b) => (a.order || 0) - (b.order || 0));
                    setServicesEditFields(merged);
                }
            }catch(e){
                console.error(e);
            }
        }
    }, [data]);


    const reloadData = () =>{
        if(!data?.Id) return;
        const ddd = new E2Data("EU_AOrg_ServicesEndpoints");
        ddd.filter = `Id="${data.Id}"`;
        ddd.GetData().then(res => {
            console.log(res);
            if(res?.result?.data?.length > 0){
                setData(res.result.data[0]);
                reset(res.result.data[0]); 
            }
        });
    }
    const onSubmit = async(newData) => {
        setDeactivateBtn(true);
        let filtered =getEditableData(newData);
        filtered.Activated=false;
        ddd.values = filtered;
        ddd.filter = `Id="${data.Id}"`
        const bres = await fiscForm?.current?.onBeforeSave(newData);
        const wbres = await workflowsForm?.current?.onBeforeSave(newData);
        ddd.Modify().then(async res => {
            setDeactivateBtn(false);
            const ares = await fiscForm?.current?.onAfterSave(newData);
            const wares = await workflowsForm?.current?.onAfterSave(newData);
            onFiscResponse(bres, ares, wbres, wares);
            _ddd.InvalidateSessionExtensions();
            NotificationManager.success(t("Channel updated"), t("Success"), 4000);
            if(submitCallback)
                submitCallback(filtered, res)
        })
    }

    const onFiscResponse = (before, after, wb, wa) => {
        let error = "";
        if(before && before?.length > 0){
            before.forEach(b => error += b?.error?.data || b?.error?.message || b?.error?.Reason || t("Unknown error occured"));
        }
        if(after && after?.length > 0){
            after.forEach(b => error += b?.error?.data || b?.error?.message || b?.error?.Reason || t("Unknown error occured"));
        }
        if(wb && wb?.length > 0){
            wb.forEach(b => error += b?.error?.data || b?.error?.message || b?.error?.Reason || t("Unknown error occured"));
        }
        if(wa && wa?.length > 0){
            wa.forEach(b => error += b?.error?.data || b?.error?.message || b?.error?.Reason || t("Unknown error occured"));
        }
        if(error.length === 0) return;

        setError(error);
        setTimeout(() => {
            setError(null);
        }, 10000);
    }

    const _setError = (str, timer = 10000) =>{
        setError(str);
        setTimeout(() => {
            setError(null);
        }, timer);
    }

    const showActiveError = (str, timer = 5000) =>{
        setActivateError(str);
        console.log(timer);
        setTimeout(() => {
            setActivateError(null);
        }, timer);
    }

    const showTestOk = (str, timer = 5000) => {
        setTestOk(str);
        setTimeout(() => {
            setTestOk(null);
        }, timer);
    }

    const onActivateClick = (e) =>{
        e.preventDefault();
        if(deactivateBtn) return;
        setDeactivateBtn(true);
        handleSubmit((newData) =>{
            let filtered =getEditableData(newData)
            ddd.values = filtered;
            ddd.values.Activated = false;
            ddd.filter = `Id="${data.Id}"`
            ddd.Modify().then(res => {
                ActivateChannel(e);
            })
        })();
    }

    const onTestClick = (e) =>{
        e.preventDefault();
        if(deactivateBtn) return;
        setDeactivateBtn(true);
        handleSubmit((newData) =>{
            let filtered = getEditableData(newData);
            console.log(filtered);
            ddd.values = filtered;
            ddd.filter = `Id="${data.Id}"`
            ddd.Modify().then(res => {
                TestChannel(newData);
            })
        })();
    }


    const ActivateChannel = () =>{
        setActivateError(null);
        let exec = data["ActExtension"] || data["ServiceEndPointCode__ActExtension"];
        if(!exec){
            setDeactivateBtn(false);
            return showActiveError("No extension found to exectute");
        }

        let memory = {...data};
        memory.Session = sessionInfo;
        const extStr = stringExpressionReplacement(exec, memory);
        let ext;
        try{
            ext = JSON.parse(extStr);
        }catch{
            setDeactivateBtn(false);
            return showActiveError("Unable to parse expression. Contact administrator.")
        }

        if(!ext || !ext.method){
            setDeactivateBtn(false);
            return showActiveError("No extension or method found. Contact administrator.");
        }

        _ddd.Rpc_ExecuteExtension(ext.method, ext.params).then(res => {
            setDeactivateBtn(false);
            if(res?.result?.Status === "OK"){
            }else{
                showActiveError(res?.result?.Reason || "Unknown error occured. Contact administrator.", 10000);
            }
            if(submitCallback)
                submitCallback()
            console.log(res);
        });
    }

    const TestChannel = (newData) =>{
        setActivateError(null);
        let exec = data["ActExtension"] || data["ServiceEndPointCode__ActExtension"];
        if(!exec){
            return restoreDataAndStopTest(newData,"No extension found to exectute");
        }

        let memory = {...data};
        memory.Session = sessionInfo;
        const extStr = stringExpressionReplacement(exec, memory);
        let ext;
        try{
            ext = JSON.parse(extStr);
        }catch{
            return restoreDataAndStopTest(newData,"Unable to parse expression. Contact administrator.")
        }

        if(!ext || !ext.method){
            return restoreDataAndStopTest(newData,"No extension or method found. Contact administrator.");
        }

        let params = ext.params || {};
        params.TestConnectionOnly = true;
        _ddd.Rpc_ExecuteExtension(ext.method, params).then(res => {
            if(res?.result?.Status === "OK"){
                restoreDataAndStopTest(newData,null, "Ok");
            }else{
                restoreDataAndStopTest(newData,res?.result?.Reason || "Unknown error occured. Contact administrator.");
            }
            /*if(submitCallback)
                submitCallback()*/
        });
    }

    const restoreDataAndStopTest = (newData,err, ok) =>{
        let filtered = getEditableData(data);
        for(let key in newData){
            if(!filtered.hasOwnProperty(key))
                filtered[key] = null;
        }
        ddd.values = filtered;
        ddd.filter = `Id="${data.Id}"`
        ddd.Modify().then(res => {
            setDeactivateBtn(false);
            if(err)
                showActiveError("No extension or method found. Contact administrator.");
            if(ok)
                showTestOk("Ok");
        })
    }

    const onCancelConfirm = () =>{
        setConfirmDialog(false);
    }

    const onCancelAnafConfirm = () =>{
        setConfirmAnafDialog(false);
    }

    const onConfirmPackageChange = () =>{
        setConfirmDialog(false);
        handleSubmit(onSubmit)();
    }

    const onConfirmAnafRevoke = () =>{
        setConfirmAnafDialog(false);
        revokeToken();
    }

    const onSaveClick = (e) =>{
        e.preventDefault();
        if(deactivateBtn) return;

        if(data["Activated"])
            return setConfirmDialog(true);

        handleSubmit(onSubmit)();
    }

    const generateAnafToken = () =>{
        let ret = window.location.origin+"/api-keys-and-credentials?check=anaf";
        window.location.href =  window.location.origin+"/oauth/Anaf.ro?ReturnUrl="+encodeURIComponent(ret);
    }

    const testToken = () => {
        setTokenLoading(true);
        axios.get(apiSource+"/oauth/Anaf.ro/status", { withCredentials: true }).then((res) => {
                setTokenLoading(false);
                console.log("Test token response:", res.data);
                const status = res.data?.Status?.toUpperCase();
                if (status === "ERROR") {
                    _setError(res.data?.Reason || "Unknown error from server");
                } else if (status === "OK") {
                    reloadData();
                    NotificationManager.success(t("Token is valid"), t("Success"), 4000);
                } else {
                    _setError(t("Unexpected response from server"));
                }
            }).catch((err) => {
                setTokenLoading(false);
                _setError(err?.message ||  t("Error testing token"));
                console.error("Error testing token:", err);
        });
    };

    const revokeToken = () => {
        setTokenLoading(true);
        axios.post(apiSource + "/oauth/Anaf.ro/revoke", null, { withCredentials: true })
            .then((res) => {
                setTokenLoading(false);
                console.log("Revoke token response:", res.data);
                const status = res.data?.Status?.toUpperCase();
                if (status === "ERROR") {
                    _setError(res.data?.Reason || "Unknown error from server");
                } else if (status === "OK") {
                    reloadData();
                    NotificationManager.success(t("Token revoked successfully"), t("Success"), 4000);
                } else {
                    _setError(t("Unexpected response from server"));
                }
            })
            .catch((err) => {
                setTokenLoading(false);
                _setError(err?.message || t("Error revoking token"));
                console.error("Error revoking token:", err);
            });
    };


    const onOpenInstructions = (e) =>{
        e.preventDefault();
        setInstructionsDialog(true);
    }

    const handlePrint = () => {
        const iframe = document.getElementById("instructions-iframe");
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.print();
        }
    };

    const handleToggle = (groupName) => {
        setOpenLongTooltips(prev => ({
            ...prev,
            [groupName]: !prev[groupName]
        }));
    };

    const fiscGroup = fieldsLayout?.find(g => g.name === "fiscalization");
    const additionalGroup = fieldsLayout?.find(g => g.name === "additional");
    const isTokenExpiringSoon = (() => {
        const validTo = data?.RefreshTokenValidTo ? new Date(data.RefreshTokenValidTo) : null;
        if (!validTo || isNaN(validTo)) return false;
        const oneMonthBefore = new Date(validTo);
        oneMonthBefore.setMonth(validTo.getMonth() - 1);
        return new Date() >= oneMonthBefore;
    })();

    /*useEffect(() => {
        const dd = new DDD(apiRequestAddress);
        dd.Rpc_ExecuteExtension("EUeInvoices.OAuthOrRefreshTokenActive", { "SiteAcronym":"AnafRO"}).then(res => {
            if(res?.result.Result.HasValidAccessToken === true){
                setAnafToken(true);
            }
        });
    }, []);*/
    return (
        <>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={confirmDialog}>
            <DialogTitle>{t("Confirm save override")}</DialogTitle>
            <DialogContent dividers>
            {t("This service is currently validated. Saving will deactivate this service and will have to be activated again.")}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onCancelConfirm}>
                {t("Cancel")}
                </Button>
                <Button onClick={onConfirmPackageChange}>{t("Ok")}</Button>
            </DialogActions>
        </Dialog>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={confirmAnafDialog}>
            <DialogTitle>{t("Confirm token revoke")}</DialogTitle>
            <DialogContent dividers>
            {t("Are you sure you want to revoke the ANAF token?")}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onCancelAnafConfirm}>
                {t("Cancel")}
                </Button>
                <Button onClick={onConfirmAnafRevoke}>{t("Ok")}</Button>
            </DialogActions>
        </Dialog>
        {/* <Dialog
        sx={{ "& .MuiDialog-paper": { width: "90%", maxWidth: "900px", height: "80%" } }}
        maxWidth={false}
        open={instructionsDialog}
        onClose={() => setInstructionsDialog(false)}
        >
        <DialogTitle>{t("Instructions")}</DialogTitle>
        <DialogContent dividers={false} sx={{ p: 0, overflow: "hidden" }}>
            <iframe
            srcDoc={data["ServiceEndPointCode__ChannelInstructions"]}
            style={{
                width: "100%",
                height: "100%",
                border: "none",
            }}
            title="Instructions"
            />
        </DialogContent>
        <DialogActions>
            <Button autoFocus onClick={() => setInstructionsDialog(false)}>
            {t("Close")}
            </Button>
        </DialogActions>
        </Dialog> */}
        <Dialog
      PaperComponent={PaperComponent}
      sx={{
        "& .MuiDialog-paper": { width: "90%", maxWidth: "900px", height: "80%", /* resize: "both", overflow: "auto"  */},
      }}
      maxWidth={false}
      open={instructionsDialog}
      onClose={() => setInstructionsDialog(false)}
    >
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        {t("Instructions")}
      </DialogTitle>

      <DialogContent dividers={false} sx={{ p: 0, overflow: "hidden" }}>
        <iframe
          id="instructions-iframe"
          srcDoc={data["ServiceEndPointCode__ChannelInstructions"]}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          title="Instructions"
        />
      </DialogContent>

      <DialogActions>
        <Button style={{padding:"0 1rem"}} onClick={handlePrint}><PrintIcon style={{marginRight:"0.5rem"}}/>{t("Print")}</Button>
        <Button autoFocus style={{padding:"0 1rem"}} onClick={() => setInstructionsDialog(false)}>
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
        <Container className={classes["formContainer"]}>
            {/* <p>{data["ServiceEndPointCode__Step__StepDescription"] || data["Step__StepDescription"]}</p> */}
            <div className={classes["title-row"]}>
                {data["ServiceEndPointCode__ChannelInstructions"] && <button
                    className={classes["instructions-btn"]}
                    onClick={onOpenInstructions}
                >
                    {t("Instructions")}
                    <HelpOutlineIcon fontSize="small" style={{ marginLeft: "0.25rem" }} />
                </button>}

                <span className={classes["title-text"]}>
                    {data["ServiceEndPointCode__Step__StepDescription"] || data["Step__StepDescription"]}
                </span>
            </div>
            <form onSubmit={onSaveClick} autocomplete="off">
            {fieldsLayout && fieldsLayout?.length > 0 && fieldsLayout.map((group, gindex) => {
                if(!isGroupEditable(group.name)) return <></>;
                const isOpen = openLongTooltips[group.name] || false;
                return <>
                    <div key={"group-"+gindex}>
                        <div className={`${classes.headerBase} ${group.longDescription ? classes.clickableHeader : ""}`} onClick={() => group.longDescription && handleToggle(group.name)}>
                            {group.longDescription && (
                                <KeyboardArrowDownIcon
                                    style={{
                                        cursor: "pointer",
                                        marginRight: "0.3rem",
                                        marginBottom: "0.3rem",
                                        transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)",
                                        transition: "transform 0.3s ease"
                                    }}
                                />
                            )}
                            <h3 className={classes.subtitle} style={{ margin: 0, display: "flex", alignItems: "center" }}>
                                {group.caption}
                                {group.tooltip && <OverlayTrigger placement="top" overlay={<Tooltip id="long-tooltip" style={{ maxWidth: "400px", whiteSpace: "normal" }}>{group.tooltip}</Tooltip>} >
                                    <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                                </OverlayTrigger>}
                            </h3>
                        </div>
                        {group.longDescription && (
                            <Collapse in={isOpen}>
                                <div
                                    style={{
                                        marginTop: "0.5rem",
                                        padding: "0.75rem",
                                        borderLeft: "4px solid var(--main-blue)",
                                        backgroundColor: "rgba(0, 123, 255, 0.05)",
                                        borderRadius: "4px",
                                        transition: "all 0.3s ease",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: group.longDescription }}
                                />
                            </Collapse>
                        )}
                        <div className={classes.Fcontainer}>
                            {servicesEditFields.filter(s => s.group === group.name).map((field, index) => {
                                if(!isFieldEditable(field.name))
                                    return <></>;
                                return(
                                    <Fragment key={"f"+field+index}>
                                    <fieldset key={field.name+index} className={classes["input-container"]} style={field.type === "textarea" ? {width:"100%"} : {}}>
                                        <label htmlFor={field.name}>
                                            {field.caption||field.name}
                                            {field.tooltip && <>
                                                <GenericTooltip tooltip={field.tooltip} fieldName={field.name} placement="top"/>
                                            </>}
                                        </label>
                                        {/* {getFieldElement(field.name)} */}
                                        {getFieldElement(field.name, field.type === "textarea" ? {style:{width:"100%"}} : {})}
                                    </fieldset>
                                    </Fragment>
                                    )
                            })}
                        </div>
                    </div></>
            })}
            {/* {isGroupEditable("service") && <>
            <h3 className={classes.subtitle}>Service</h3>
            <div className={classes.Fcontainer}>
                {servicesEditFields.filter(s => s.group === "service").map((field, index) => {
                    if(!isFieldEditable(field.name))
                        return <></>;
                    return(
                        <fieldset key={field.name+index} className={classes["input-container"]}>
                            <label htmlFor={field.name}>
                                {field.caption||field.name}
                                {field.tooltip && <>
                                    <GenericTooltip tooltip={field.tooltip} fieldName={field.name} placement="left"/>
                                </>}
                            </label>
                            {getFieldElement(field.name)}
                        </fieldset>
                        )
                })}
            </div>
            </>}

            {isGroupEditable("mail") && <>
            <h3 className={classes.subtitle}>Mail</h3>
            <div className={classes.Fcontainer}>
                {servicesEditFields.filter(s => s.group === "mail").map((field, index) => {
                    if(!isFieldEditable(field.name))
                        return <></>;
                    return(
                        <fieldset key={field+index} className={classes["input-container"]}>
                            <label htmlFor={field.name}>{field.caption||field.name}</label>
                            {getFieldElement(field.name)}
                        </fieldset>
                        )
                })}
            </div>
            </>}

            {isGroupEditable("login") && <>
            <h3 className={classes.subtitle}>Login</h3>
            <div className={classes.Fcontainer}>
                {servicesEditFields.filter(s => s.group === "login").map((field, index) => {
                    if(!isFieldEditable(field.name))
                        return <></>;
                    return(
                        <fieldset key={field+index} className={classes["input-container"]}>
                            <label htmlFor={field.name}>{field.caption||field.name}</label>
                            {getFieldElement(field.name)}
                        </fieldset>
                        )
                })}
            </div>
            </>}

            {isGroupEditable("cert") && <>
            <h3 className={classes.subtitle}>Certificate</h3>
            <div className={classes.Fcontainer}>
                {servicesEditFields.filter(s => s.group === "cert").map((field, index) => {
                    if(!isFieldEditable(field.name))
                        return <></>;
                    return(
                        <fieldset key={field+index} className={classes["input-container"]}>
                            <label htmlFor={field.name}>{field.caption||field.name}</label>
                            {getFieldElement(field.name)}
                        </fieldset>
                        )
                })}
            </div>
            </>} */}
            {unlistedFields.length >0 && <>
            <h3 className={classes.subtitle}>Other</h3>
            <div className={classes.Fcontainer}>
                {unlistedFields.map((field, index) => {
                    const info = getFieldInfo(field);
                    return(
                        <fieldset key={field+index} className={classes["input-container"]} style={info?.FieldType==="TextArea" ? {flexBasis:"100%"} : {}}>
                            <label htmlFor={field}>{info?.FieldCaption||field}</label>
                            {getFieldElement(field, info?.FieldType==="TextArea" ? {width:"100%"} : {})}
                        </fieldset>
                        )
                })}
            </div>
            </>}
            {isGroupEditable(undefined) && <>
            <h3 className={classes.subtitle}>Other</h3>
            <div className={classes.Fcontainer}>
                {servicesEditFields.filter(s => s.group === undefined).map((field, index) => {
                    if(!isFieldEditable(field.name))
                        return <></>;
                    return(
                        <fieldset key={field+index} className={classes["input-container"]}>
                            <label htmlFor={field.name}>{field.caption||field.name}</label>
                            {getFieldElement(field.name)}
                        </fieldset>
                        )
                })}
            </div>
            </>}
            {/* {isGroupEditable("notes") && <>
            <h3 key="Note-title" className={classes.subtitle}>Note</h3>
            <div key="Note-cont" className={classes.Fcontainer}>
                {servicesEditFields.filter(s => s.name === "Notes").map((field, index) => {
                    if(!isFieldEditable(field.name))
                        return <></>;
                    return(<Fragment key={"f"+field+index}>
                        <fieldset key={field+index} className={classes["input-container"]} style={{width:"100%"}}>
                            <label key={"label"+field+index} htmlFor={field.name}>
                                {field.caption||field.name}
                            </label>
                            {getFieldElement(field.name, {style:{width:"100%"}})}
                        </fieldset>
                        </Fragment>)
                })}
            </div>
            </>} */}
            {/* <div className={`${classes.headerBase} ${group.longDescription ? classes.clickableHeader : ""}`} onClick={() => group.longDescription && handleToggle(group.name)}>
                            {group.longDescription && (
                                <KeyboardArrowDownIcon
                                    style={{
                                        cursor: "pointer",
                                        marginRight: "0.3rem",
                                        marginBottom: "0.3rem",
                                        transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)",
                                        transition: "transform 0.3s ease"
                                    }}
                                />
                            )}
                            <h3 className={classes.subtitle} style={{ margin: 0, display: "flex", alignItems: "center" }}>
                                {group.caption}
                                {group.tooltip && <OverlayTrigger placement="top" overlay={<Tooltip id="long-tooltip" style={{ maxWidth: "400px", whiteSpace: "normal" }}>{group.tooltip}</Tooltip>} >
                                    <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                                </OverlayTrigger>}
                            </h3>
                        </div>
                        {group.longDescription && (
                            <Collapse in={isOpen}>
                                <div
                                    style={{
                                        marginTop: "0.5rem",
                                        padding: "0.75rem",
                                        borderLeft: "4px solid var(--main-blue)",
                                        backgroundColor: "rgba(0, 123, 255, 0.05)",
                                        borderRadius: "4px",
                                        transition: "all 0.3s ease",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: group.longDescription }}
                                />
                            </Collapse>
                        )} */}
            {connectedFields?.length > 0 && <>
                <h3 className={classes.subtitle}>Connections</h3>

                {connectedFields.map((field, index) => {
                    const info = getFieldInfo(field);
                    const val = getFieldValue(field);
                    return(
                        <div key={field+index} className="text-start">
                            <span className="fw-bold pe-2">{field}:</span>{val}
                        </div>
                        )
                })}
            </>}
            {data["ServiceEndPointCode__Step"] === "40" && fiscGroup?.display!==false &&<>
                {fiscGroup && <>
                    <div className={`${classes.headerBase} ${fiscGroup.longDescription ? classes.clickableHeader : ""}`} onClick={() => fiscGroup.longDescription && handleToggle(fiscGroup.name)}>
                        {fiscGroup.longDescription && (
                            <KeyboardArrowDownIcon
                                style={{
                                    cursor: "pointer",
                                    marginRight: "0.3rem",
                                    marginBottom: "0.3rem",
                                    transform: openLongTooltips[fiscGroup.name]===true ? "rotate(0deg)" : "rotate(-90deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        )}
                        <h3 className={classes.subtitle} style={{ margin: 0, display: "flex", alignItems: "center" }}>
                            {fiscGroup.caption}
                            {fiscGroup.tooltip && <OverlayTrigger placement="top" overlay={<Tooltip id="long-tooltip" style={{ maxWidth: "400px", whiteSpace: "normal" }}>{fiscGroup.tooltip}</Tooltip>} >
                                <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                            </OverlayTrigger>}
                        </h3>
                    </div>
                    {fiscGroup.longDescription && (
                            <Collapse in={openLongTooltips[fiscGroup.name]===true}>
                                <div
                                    style={{
                                        marginTop: "0.5rem",
                                        padding: "0.75rem",
                                        borderLeft: "4px solid var(--main-blue)",
                                        backgroundColor: "rgba(0, 123, 255, 0.05)",
                                        borderRadius: "4px",
                                        transition: "all 0.3s ease",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: fiscGroup.longDescription }}
                                />
                            </Collapse>
                        )}
                </>}
                {!fiscGroup && <div className={classes.headerBase}>
                        <h3 className={classes.subtitle} style={{ margin: 0, display: "flex", alignItems: "center" }}>
                        Fiscalization
                        </h3>
                    </div>}
                <div className="d-flex w-100" style={{flexWrap:"wrap", gap: "1rem", marginBottom: "1rem"}}>
                    <FiscalizationForm deviceId={connectionKey} ref={fiscForm} orgData={orgData}/>
                </div>
                </>}
            {instructions && <>
                {additionalGroup && <>
                    <div className={`${classes.headerBase} ${additionalGroup.longDescription ? classes.clickableHeader : ""}`} onClick={() => additionalGroup.longDescription && handleToggle(additionalGroup.name)}>
                        {additionalGroup.longDescription && (
                            <KeyboardArrowDownIcon
                                style={{
                                    cursor: "pointer",
                                    marginRight: "0.3rem",
                                    marginBottom: "0.3rem",
                                    transform: openLongTooltips[additionalGroup.name]===true ? "rotate(0deg)" : "rotate(-90deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        )}
                        <h3 className={classes.subtitle} style={{ margin: 0, display: "flex", alignItems: "center" }}>
                            {additionalGroup.caption}
                            {additionalGroup.tooltip && <OverlayTrigger placement="top" overlay={<Tooltip id="long-tooltip" style={{ maxWidth: "400px", whiteSpace: "normal" }}>{additionalGroup.tooltip}</Tooltip>} >
                                <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                            </OverlayTrigger>}
                        </h3>
                    </div>
                    {additionalGroup.longDescription && (
                            <Collapse in={openLongTooltips[additionalGroup.name]===true}>
                                <div
                                    style={{
                                        marginTop: "0.5rem",
                                        padding: "0.75rem",
                                        borderLeft: "4px solid var(--main-blue)",
                                        backgroundColor: "rgba(0, 123, 255, 0.05)",
                                        borderRadius: "4px",
                                        transition: "all 0.3s ease",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: additionalGroup.longDescription }}
                                />
                            </Collapse>
                        )}
                </>}
                {!additionalGroup && <>
                    <div className={classes.headerBase}>
                        <h3 className={classes.subtitle} style={{ margin: 0, display: "flex", alignItems: "center" }}>
                        Other
                        </h3>
                    </div>
                </>}
                <div className="d-flex w-100" style={{flexWrap:"wrap", gap: "1rem"}}>
                    <ServicesFormWorkflows deviceId={connectionKey} ref={workflowsForm} orgData={orgData} instructions={instructions} importedData={importedData}/>
                </div>
            </>}
            {activateError && <>
                <div className="alert alert-danger" role="alert">
                {activateError}
                </div>
            </>}
            {testOk && <>
                <div className="alert alert-success" role="alert">
                {testOk}
                </div>
            </>}
            {error && <div className="alert alert-danger mt-2 w-100">{error}</div>}
            {editable && <div style={{textAlign:"right"}}>
                {/* {(data["ServiceEndPointCode__ActExtension"] || data["ActExtension"]) && isMaintainer && <>
                    {data["Activated"] !== true && <> 
                        <Button style={{marginRight:"1rem"}} onClick={onActivateClick} disabled={deactivateBtn}>Activate</Button>
                        <Button style={{marginRight:"1rem"}} onClick={onTestClick} disabled={deactivateBtn}>Test connection</Button>
                    </>}
                </>} */}
                {(data["ServiceEndPointCode__ActExtension"] || data["ActExtension"]) && <>
                    {data["Activated"] !== true && <> 
                        <Button style={{marginRight:"1rem"}} onClick={onActivateClick} disabled={deactivateBtn}>{t("Activate")}</Button>
                        <Button style={{marginRight:"1rem"}} onClick={onTestClick} disabled={deactivateBtn}>{t("Test connection")}</Button>
                    </>}
                    {data["Activated"] && <>
                        <span style={{color:"green"}}>Channel {t("is validated")}</span>
                        <CheckCircleIcon style={{color:"green", marginLeft:"1rem", marginRight:"1rem"}}/>
                    </>}
                </>}
                {data["ServiceEndPointCode"] === "ROe-Invoice" && <>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="long-tooltip" style={{ maxWidth: '400px', whiteSpace: 'normal', padding: '1rem' }}>
                            <div>
                                <strong>Process of obtaining ANAF token:</strong>
                                <ul style={{ paddingLeft: '1rem', marginBottom: 0 }}>
                                    <li>You will be redirected to <code>{`${window.location.origin}/oauth/Anaf.ro`}</code> to generate the URI for ANAF.</li>
                                    <li>Then redirected to ANAF’s login site <code>https://logincert.anaf.ro</code> to enter your credentials.</li>
                                    <li>After approval, ANAF redirects back to our service with the token.</li>
                                    <li>We redirect you back to this dashboard: <code>{`${window.location.origin}/api-keys-and-credentials?check=anaf`}</code></li>
                                    <li>The token is stored, and data refreshes automatically.</li>
                                </ul>
                            </div>
                            </Tooltip>
                        }
                        >     
                        <Button disabled={isTokenExpiringSoon || tokenLoading} style={{marginRight:"1rem",paddingLeft:"7px", paddingRight:"7px"}} onClick={generateAnafToken}>{t("Get new token")}{/* {!data["AccessToken"] && <>Get ANAF token</>}{data["AccessToken"] && <>Token valid<CheckCircleIcon style={{color:"green", marginLeft:"1rem"}}/></>} */}</Button>
                    </OverlayTrigger>
                    <Button disabled={isTokenExpiringSoon || tokenLoading} style={{marginRight:"1rem",paddingLeft:"7px", paddingRight:"7px"}} onClick={(e) => {e.preventDefault(); setConfirmAnafDialog(true)}}>{t("Revoke token")}</Button>
                    <Button disabled={isTokenExpiringSoon || tokenLoading} style={{marginRight:"1rem",paddingLeft:"7px", paddingRight:"7px"}} onClick={testToken}>{t("Check token")}</Button>
                </>}
                {data["ServiceEndPointCode"] === "MailSend" && <><Button className="ps-2 pe-2" style={{marginRight:"1rem"}} onClick={() => navigate("/mail-creator")} disabled={deactivateBtn}>{t("Modify/Create mail template")}</Button></>}
                {data["ServiceEndPointCode__Step"] === "40" && 
                    <Button style={{marginRight:"1rem"}} className="ps-2 pe-2" onClick={() => {navigate('/presets-devices');}}>{t("My devices")}</Button>
                }
                <Button type="submit" className="ps-2 pe-2" disabled={deactivateBtn}>Save</Button>
            </div>}
            {!editable  && <div style={{textAlign:"right"}}>
                {data["ServiceEndPointCode"] === "MailSend" && <><Button className="ps-2 pe-2" style={{marginRight:"1rem"}} onClick={() => navigate("/mail-creator")} disabled={deactivateBtn}>{t("Modify/Create mail template")}</Button></>}
            </div>}
            </form>
            </Container>
        </>
    )
}

export default ServiceForm;

const PaperComponent = (props) => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}